'use client'

import { Button } from '@chakra-ui/react'
import { createContext } from 'react'

const ButtonContext = createContext(Button)

export default ButtonContext
